import type { LucideIcon } from 'lucide-react';
import { cn } from '@clarix/ui/lib/cn';

interface MicNoticeProps {
  icon: LucideIcon;
  title: string;
  body?: string;
  /** `alert` for something that blocks recording; omit when a live region elsewhere announces it. */
  role?: 'alert' | 'status';
  className?: string;
}

/** The amber microphone warning: blocked, lost, or not hearing speech. */
export function MicNotice({ icon: Icon, title, body, role, className }: MicNoticeProps) {
  return (
    <div className={cn('border-warning/40 bg-warning-light text-warning-fg rounded-md border p-2', className)} role={role}>
      <p className="text-md flex items-start gap-1.5 font-medium">
        <Icon className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden />
        {title}
      </p>
      {body && <p className="text-md mt-1">{body}</p>}
    </div>
  );
}
